import { postDataSecurityAccessAnomalyAlertsExportStart } from '@api';

import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const postCoreDataSecurityAccessAnomalyAlertsExportSlice = createPostAsyncSlice({
	name: 'CoreDataSecurityAccessAnomalyAlertsExport',
	receive: true,
	request: true,
	requestHandler: postDataSecurityAccessAnomalyAlertsExportStart,
	retainDataOnRequest: false,
	yieldType: SagaYieldType.Every
});
